<template>
  <div class="flex flex-col lg:flex-row gap-2 lg:gap-4">
    <ExtraGuaranteeOption
      v-for="option in guaranteeOptions"
      :key="option.sku"
      :option="option"
      :is-selected="selectedOption === option.sku"
      :is-best-deal="highestGuaranteeOptionSku === option.sku"
      @select="handleSelect"
    />
  </div>
</template>

<script lang="ts">

import type { ProductVariantExtended } from '~~/types/product/ProductVariantExtended';

export default defineComponent({
  name: 'ExtraGuaranteeOptions',

  props: {
    extraGuaranteeSku: {
      type: String,
      required: true,
    },
    product: {
      type: Object as PropType<ProductVariantExtended>,
      default: null,
    },
  },
  emits: ['update:selectedOption'],
  setup(props, { emit }) {

    const { guaranteeOptions, highestGuaranteeOptionSku } = useExtraGuaranteeOptions(props.product);
    const selectedOption = ref(null);

    onMounted(() => {

      handleSelect({ sku: props.extraGuaranteeSku || highestGuaranteeOptionSku.value });
    
    });

    const handleSelect = (option) => {

      selectedOption.value = selectedOption.value === option.sku ? null : option.sku;
      emit('update:selectedOption', selectedOption.value);
    
    };

    return {
      guaranteeOptions,
      selectedOption,
      highestGuaranteeOptionSku,
      handleSelect,
    };
  
  },
});

</script>
